module.exports = __webpack_public_path__ + "img/AVIATOR CLASSIC.fa6b5e7d.jpg";